function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

function _readOnlyError(name) { throw new TypeError("\"" + name + "\" is read-only"); }

// modified from https://github.com/wmlgl/cropperjs-gif/blob/master/src/cropperjs-gif.js

/**
 * a plugin support cropperjs to crop gif image
 *
 * options:
 *  background: "#fff" default background color
 *  maxWidth: output image max width
 *  maxHeight: output image max height
 *  src: original image url (blob, base64, http)
 *  onError: error callback, onError(errorCode, error|null)
 */
import EasyGif from './EasyGif';
var ERROR = {
  IMAGE_LOAD_ERROR: 'IMAGE_LOAD_ERROR',
  IMAGE_READ_ERROR: 'IMAGE_READ_ERROR',
  DECODE_ERROR: 'DECODE_ERROR',
  ENCODE_ERROR: 'ENCODE_ERROR'
};
var nextTick = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.setTimeout;

var _calcLimitRatio = /*#__PURE__*/_classPrivateFieldLooseKey("calcLimitRatio");

var _readAndDecodeGif = /*#__PURE__*/_classPrivateFieldLooseKey("readAndDecodeGif");

var _decode = /*#__PURE__*/_classPrivateFieldLooseKey("decode");

var _setupCanvas = /*#__PURE__*/_classPrivateFieldLooseKey("setupCanvas");

var _cropFrame = /*#__PURE__*/_classPrivateFieldLooseKey("cropFrame");

var _drawImgDataToCanvas = /*#__PURE__*/_classPrivateFieldLooseKey("drawImgDataToCanvas");

var _saveGif = /*#__PURE__*/_classPrivateFieldLooseKey("saveGif");

var _errorHandler = /*#__PURE__*/_classPrivateFieldLooseKey("errorHandler");

var GifCropper = /*#__PURE__*/function () {
  function GifCropper(_options) {
    _classCallCheck(this, GifCropper);

    Object.defineProperty(this, _errorHandler, {
      value: _errorHandler2
    });
    Object.defineProperty(this, _saveGif, {
      value: _saveGif2
    });
    Object.defineProperty(this, _drawImgDataToCanvas, {
      value: _drawImgDataToCanvas2
    });
    Object.defineProperty(this, _cropFrame, {
      value: _cropFrame2
    });
    Object.defineProperty(this, _setupCanvas, {
      value: _setupCanvas2
    });
    Object.defineProperty(this, _decode, {
      value: _decode2
    });
    Object.defineProperty(this, _readAndDecodeGif, {
      value: _readAndDecodeGif2
    });
    Object.defineProperty(this, _calcLimitRatio, {
      value: _calcLimitRatio2
    });
    _options.background = _options.background || '#fff';
    this.options = _options;
    this.containerCanvas = document.createElement('canvas');
    this.containerCtx = this.containerCanvas.getContext('2d');
    this.convertorCanvas = document.createElement('canvas');
    this.convertorCtx = this.convertorCanvas.getContext('2d');
    this.containerCenterX = null;
    this.containerCenterY = null;
    this.image = null;
    this.height = null;
    this.width = null;

    if (_options.debug) {
      (function (callback) {
        setTimeout(callback, 500);
      }), _readOnlyError("nextTick");
      this.containerCanvas.style.width = '200px';
      this.convertorCanvas.style.width = '200px';
      document.body.insertBefore(this.containerCanvas, document.body.firstChild);
      document.body.insertBefore(this.convertorCanvas, document.body.firstChild);
    }
  }

  _createClass(GifCropper, [{
    key: "crop",
    value: function crop(cropper, callback) {
      var cropArea = cropper.getData();
      var that = this;

      var limitRatio = _classPrivateFieldLooseBase(this, _calcLimitRatio)[_calcLimitRatio](cropArea);

      var limitCropArea = {
        x: Math.round(cropArea.x * limitRatio),
        y: Math.round(cropArea.y * limitRatio),
        width: Math.round(cropArea.width * limitRatio),
        height: Math.round(cropArea.height * limitRatio),
        scaleX: cropArea.scaleX * limitRatio,
        scaleY: cropArea.scaleY * limitRatio,
        rotate: cropArea.rotate
      };

      _classPrivateFieldLooseBase(this, _readAndDecodeGif)[_readAndDecodeGif](function () {
        _classPrivateFieldLooseBase(that, _setupCanvas)[_setupCanvas](limitCropArea, limitRatio);

        _classPrivateFieldLooseBase(that, _cropFrame)[_cropFrame](0, limitCropArea, [], function (result) {
          _classPrivateFieldLooseBase(that, _saveGif)[_saveGif](limitCropArea, result, function (cropBlob) {
            callback && callback(cropBlob);
          });
        });
      });
    }
  }]);

  return GifCropper;
}();

function _calcLimitRatio2(cropArea) {
  var xRatio = this.options.maxWidth / cropArea.width;
  var yRatio = this.options.maxHeight / cropArea.height;

  if (xRatio < 1 || yRatio < 1) {
    return Math.min(xRatio, yRatio);
  }

  return 1;
}

function _readAndDecodeGif2(callback) {
  var that = this;
  this.image = new Image();

  this.image.onload = function () {
    that.width = this.naturalWidth || this.width;
    that.height = this.naturalHeight || this.height;
    var xhr = new XMLHttpRequest();
    xhr.responseType = 'arraybuffer';

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          _classPrivateFieldLooseBase(that, _decode)[_decode](xhr.response, callback);
        } else {
          _classPrivateFieldLooseBase(that, _errorHandler)[_errorHandler](ERROR.IMAGE_READ_ERROR, new Error(xhr.statusText));
        }
      }
    };

    xhr.open('GET', that.options.src);
    xhr.send(null);
  };

  this.image.onerror = function () {
    _classPrivateFieldLooseBase(that, _errorHandler)[_errorHandler](ERROR.IMAGE_LOAD_ERROR);
  };

  this.image.src = this.options.src;
}

function _decode2(arraybuffer, callback) {
  try {
    this.frames = EasyGif.decoder(arraybuffer);
    if (callback) callback();
  } catch (error) {
    _classPrivateFieldLooseBase(this, _errorHandler)[_errorHandler](ERROR.DECODE_ERROR, error);
  }
}

function _setupCanvas2(cropArea, limitRatio) {
  var radian = Math.PI / 180 * cropArea.rotate;
  var rotatedBoxWidth = (this.width * Math.cos(radian) + this.height * Math.sin(radian)) * limitRatio;
  var rotatedBoxHeight = (this.height * Math.cos(radian) + this.width * Math.sin(radian)) * limitRatio;
  this.offsetX = -Math.min(cropArea.x, 0);
  this.offsetY = -Math.min(cropArea.y, 0);
  this.containerCenterX = this.offsetX + rotatedBoxWidth / 2;
  this.containerCenterY = this.offsetY + rotatedBoxHeight / 2;
  this.containerCanvas.width = Math.max(this.offsetX + rotatedBoxWidth, this.offsetX + cropArea.width, cropArea.x + cropArea.width);
  this.containerCanvas.height = Math.max(this.offsetY + rotatedBoxHeight, this.offsetY + cropArea.height, cropArea.y + cropArea.height);
  this.containerCtx.clearRect(0, 0, this.containerCanvas.width, this.containerCanvas.height);
  this.convertorCanvas.width = this.width;
  this.convertorCanvas.height = this.height;
}

function _cropFrame2(frameIndex, cropArea, result, callback) {
  var frame = this.frames[frameIndex];
  var imgData = EasyGif.frameToImageData(this.containerCtx, frame);
  var cropImgData = null;
  var that = this;
  this.containerCtx.save();
  this.containerCtx.translate(this.containerCenterX, this.containerCenterY);
  this.containerCtx.rotate(cropArea.rotate * Math.PI / 180);
  this.containerCtx.scale(cropArea.scaleX, cropArea.scaleY);
  this.containerCtx.drawImage(_classPrivateFieldLooseBase(this, _drawImgDataToCanvas)[_drawImgDataToCanvas](frame, imgData), -this.convertorCanvas.width / 2, -this.convertorCanvas.height / 2);
  this.containerCtx.restore();

  if (frameIndex == 0 && this.containerCtx.globalCompositeOperation) {
    this.containerCtx.fillStyle = this.options.background;
    this.containerCtx.globalCompositeOperation = 'destination-over';
    this.containerCtx.fillRect(0, 0, this.containerCanvas.width, this.containerCanvas.height);
    this.containerCtx.globalCompositeOperation = 'source-over';
  }

  cropImgData = this.containerCtx.getImageData(cropArea.x + this.offsetX, cropArea.y + this.offsetY, cropArea.width, cropArea.height);
  result.push(cropImgData);
  frameIndex++;

  if (frameIndex < this.frames.length) {
    nextTick(function () {
      _classPrivateFieldLooseBase(that, _cropFrame)[_cropFrame](frameIndex, cropArea, result, callback);
    });
  } else {
    callback && callback(result);
  }
}

function _drawImgDataToCanvas2(frame, imgData) {
  this.convertorCtx.clearRect(0, 0, this.width, this.height);
  this.convertorCtx.putImageData(imgData, frame.dims.left, frame.dims.top);
  return this.convertorCanvas;
}

function _saveGif2(cropArea, imgDataList, callback) {
  var options = this.options.encoder || {};
  options.width = cropArea.width;
  options.height = cropArea.height;

  try {
    var encoder = EasyGif.encoder(options);

    for (var i = 0; i < imgDataList.length; i++) {
      encoder.addFrame(imgDataList[i], {
        delay: this.frames[i].delay
      });
    }

    encoder.on('finished', function (blob) {
      callback && callback(blob);
      encoder.abort();
      var workers = encoder.freeWorkers;

      for (var _i = 0; _i < workers.length; _i++) {
        var worker = workers[_i];
        worker.terminate();
      }
    });
    encoder.render();
  } catch (error) {
    _classPrivateFieldLooseBase(this, _errorHandler)[_errorHandler](ERROR.DECODE_ERROR, error);
  }
}

function _errorHandler2(errorCode, error) {
  this.options.onError && this.options.onError(errorCode, error);
}

export { GifCropper as default };